import React from "react";
import { Card, Descriptions, Typography } from "antd";
import styles from "./OperationRequestWorkspace.module.css";

const { Text } = Typography;

/**
 * @param {{ supplierInfo: Record<string, unknown>, orderSummary: Record<string, unknown> }} props
 */
export default function OperationRequestSupplierCard({ supplierInfo, orderSummary }) {
  const contact =
    supplierInfo.contactName || orderSummary?.contacts?.primaryName || "—";
  const phone =
    supplierInfo.phone ||
    (orderSummary?.contacts?.phones?.length ? orderSummary.contacts.phones[0] : null) ||
    "—";
  const email =
    supplierInfo.email ||
    (orderSummary?.contacts?.emails?.length ? orderSummary.contacts.emails[0] : null) ||
    "—";

  return (
    <Card className={styles.sidebarCard} size="small" title="מידע ספק">
      <Descriptions column={1} size="small" colon={false}>
        <Descriptions.Item label="ספק">{supplierInfo.supplierName || "—"}</Descriptions.Item>
        <Descriptions.Item label="איש קשר">{contact}</Descriptions.Item>
        <Descriptions.Item label="טלפון">
          <Text dir="ltr">{phone}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="אימייל">
          <Text dir="ltr">{email}</Text>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
